<template>
    <div>
        
        <v-card :color="color" class="elevation-2" style="height: 320px">
            <v-card-title class="heading1">
                <LanguagePlaceholder :default-text="props.heading" />
            </v-card-title>
            <v-card-text class="text-center">
                <v-row>
                    <p class="text1 pa-4 text-left">
                        <LanguagePlaceholder :default-text="props.text" />
                    </p>
                </v-row>
                <v-row justify="center" class="mb-0">
                    <MarketingAssetsFileButton 
                        class="ma-2"
                        v-for="i in items"
                        :button-text="i.buttonText"
                        :file-name="i.fileName"
                        :container="i.container"
                        color="#00796B"
                        text-color="#ffffff"
                    />
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import MarketingAssetsFileButton from '@/components/MarketingAssetsFileButton.vue';

const systemStore = useSystemStore()

const heading = ref('')
const text = ref('')
const items = ref([])
const color = ref('')


const props = defineProps({
    heading: { type: String, default: '', required: true },
    text: { type: String, default: ''},
    items: { type: Array, default: []},
    color: { type: String, default: ''},
    height: { type: Number, default: 0},
})

onMounted(() => {
    heading.value = props.heading
    text.value = props.text
    items.value = props.items
    color.value = props.color
})

</script>

<style scoped>
.heading1 {
    font-size: 16px;
    font-weight: 500;
    color: #00796B;
}

.text1 {
    font-size: 14px;
    font-weight: 300;
    color: black;
}
</style>